import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=de4c6be0&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=de4c6be0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4c6be0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de4c6be0')) {
      api.createRecord('de4c6be0', component.options)
    } else {
      api.reload('de4c6be0', component.options)
    }
    module.hot.accept("./dashboard.vue?vue&type=template&id=de4c6be0&scoped=true", function () {
      api.rerender('de4c6be0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sales/salesReps/dashboard.vue"
export default component.exports